import { Badge } from "components";
import { config } from "constant";
import { Fragment } from "react/jsx-runtime";

export default function MagazineLoading() {
  return (
    <Fragment>
      {[...Array(config.loadingLength).keys()].map((key) => (
        <Fragment key={key}>
          <article className="w-full py-1">
            <div className="py-1 space-y-1">
              <h3 className="text-sm loading w-fit">Home decoration</h3>
              <h3 className="text-sm loading w-fit">Living Room</h3>
            </div>
            <div className="w-full grid grid-cols-3 grid-rows-2 gap-1 py-1">
              {[0, 1, 2].map((index) => {
                return (
                  <div
                    key={index}
                    className="w-full aspect-image object-cover rounded first:col-span-2 first:row-span-2 loading"
                  />
                );
              })}
            </div>
            <p className="text-sm py-1 space-y-0.5">
              <span className="loading block w-full h-5"></span>
              <span className="loading block w-4/5 h-5"></span>
              <span className="loading block w-2/3 h-5"></span>
            </p>
            <div className="flex flex-wrap gap-1 py-1">
              <Badge className="loading">#hashtag</Badge>
              <Badge className="loading">#hashtag</Badge>
              <Badge className="loading">#hashtag</Badge>
            </div>
            <div className="w-full h-10 loading"></div>
            <div className="w-full h-2.5 flex items-center">
              <hr className="border-[#ECEFF2] w-full" />
            </div>
          </article>
        </Fragment>
      ))}
    </Fragment>
  );
}
